import { render, staticRenderFns } from "./ActivityTabs.vue?vue&type=template&id=7f65a8d2&scoped=true&"
import script from "./ActivityTabs.vue?vue&type=script&lang=ts&"
export * from "./ActivityTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityTabs.vue?vue&type=style&index=0&id=7f65a8d2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f65a8d2",
  null
  
)

export default component.exports